import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import CustomTable from '../../../tables/CustomTable';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { mainColors } from '../../../../styling/theme';
import { addCommasToNumbersAndRound } from '../../../../utilities/numberFormatters';
import type { CryptoAssetTableRow } from './cryptoPage.types';

interface AssetLevelTableProps {
  data: CryptoAssetTableRow[];
  exportFileName?: string;
}

const assetLevelTableColumns: CustomColumn<CryptoAssetTableRow>[] = [
  {
    title: 'Asset Name',
    field: 'assetName',
    cellStyle: { textAlign: 'left' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'ISIN',
    field: 'isin',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'Gross Exposure',
    field: 'grossExposure',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
    render: (rowData) =>
      rowData.grossExposure == null
        ? '-'
        : addCommasToNumbersAndRound(rowData.grossExposure),
  },
  {
    title: 'Gross Exposure %',
    field: 'grossExposurePct',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
];

const useStyles = makeStyles<Theme>(() => ({
  root: {
    border: `1px solid ${mainColors.lightGrey}`,
    borderRadius: '0.25rem',
    margin: '0.62rem',
  },
}));

const AssetLevelTable: React.FC<AssetLevelTableProps> = ({
  data,
  exportFileName,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* TODO: nested CustomTable PDF export dumps every registered page
          component (ExportButton.generatePdf uses componentsForExportSelector).
          CSV is already this table only. Isolating PDF needs a systemic change
          so table-level PDF filters by identifier. Same pattern as EMIR. */}
      <CustomTable<CryptoAssetTableRow>
        columns={assetLevelTableColumns}
        showToolbar
        data={data}
        title="Asset Level Data"
        exportFileName={exportFileName}
        options={{
          paging: false,
          search: false,
          exportButton: true,
        }}
        pdfDontMoveToNewPage={true}
      />
    </div>
  );
};

export default AssetLevelTable;
